export default "__VITE_ASSET__sFmrvp4K__"